module.exports = new __parcel__URL__("shop_machines_antirat_squad_department.2a39d6c3.png").toString();